import {useLocation} from "react-router-dom";
import {useCurrentUser} from "~/auth/hooks";
import {useEffect, useMemo, useState} from "react";
import * as CE from "~/customers-experience";
import {ServiceInterviewDialog, ServiceInterviewDialogProps} from "./ServiceInterviewDialog";
import {useReactions} from "~/customers-experience/hooks";
import {useBooleanHistoryState, useStorageState} from "~/apps/core/utils";
import {useCreateServiceInterview} from "~/customers-experience/ServiceInterview/hooks";


export type ServiceInterviewProps = {
    serviceID: string
    serviceVersion: string
    children?: any
}

export const ServiceInterview = (props: ServiceInterviewProps) => {
    const {serviceID, serviceVersion, children} = props;
    const location = useLocation();
    const [user] = useCurrentUser();
    const reactions = useReactions();
    const [open, setOpen] = useBooleanHistoryState("interview");
    const [showed, setShowed] = useState(false);
    const [createServiceInterview, {loading: submitting, completed}] = useCreateServiceInterview();

    const reaction = useMemo(() => {
        if (location.pathname != "/") {
            return;
        }
        if (showed) {
            return;
        }
        if (reactions["service_interview"]) {
            for (const reaction of reactions["service_interview"]) {
                if (reaction.service == props.serviceID && reaction.version == props.serviceVersion) {
                    return reaction;
                }
            }
        }
    }, [reactions, location, showed])


    const handleClose = () => {
        setShowed(true);
        setOpen(false).then(() => {
            CE.reachTarget("reject_service_interview", {
                service: serviceID,
                version: serviceVersion,
            });
        });
    }

    const handleSubmit: ServiceInterviewDialogProps["onSubmit"] = (values) => {
        createServiceInterview({
            serviceId: serviceID,
            serviceVersion: serviceVersion,
            comment: values.comment,
            rating: values.rating,
        });
    }

    // close dialog when submit interview
    useEffect(() => {
        if (completed) {
            setShowed(true);
            CE.reachTarget("accept_service_interview", {
                service: serviceID,
                version: serviceVersion,
            });
            setOpen(false);
        }
    }, [completed, serviceID, serviceVersion])

    // close dialog when first render
    useEffect(() => {
        setOpen(false).catch(console.error);
    }, []);

    // open dialog when exists reaction
    useEffect(() => {
        if (reaction) {
            setOpen(true).catch(console.error);
        }
    }, [reaction]);

    // reach enter service
    useEffect(() => {
        if (user) {
            // CE.reachTarget("enter_service", {service: serviceID, version: serviceVersion, user_id: user.userName});
        }
    }, [user]);

    return (
        <>
            <ServiceInterviewDialog open={open}
                                    onClose={handleClose}
                                    onSubmit={handleSubmit}
                                    submitting={submitting}
            />
            {children}
        </>
    );
}